import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';

export function ClassicFooter({ switchToPremium, policyPopup, setPolicyPopup }) {
  return (
    <>
      <footer className="border-t border-border bg-foreground text-white py-12">
        <div className="container mx-auto px-8">
          {/* Trust Icons Bar */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10 pb-10 border-b border-white/10">
            <div className="flex items-center gap-3 bg-white/5 p-4 rounded-lg">
              <span className="text-2xl">🛡️</span>
              <div>
                <p className="text-sm font-bold">Secured by Ezeefit</p>
                <p className="text-xs opacity-70">Trusted since 2014</p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white/5 p-4 rounded-lg">
              <span className="text-2xl">🏗️</span>
              <div>
                <p className="text-sm font-bold">Factory Direct</p>
                <p className="text-xs opacity-70">No middlemen</p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white/5 p-4 rounded-lg">
              <span className="text-2xl">💳</span>
              <div>
                <p className="text-sm font-bold">Secure Payments</p>
                <p className="text-xs opacity-70">100% Encrypted</p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white/5 p-4 rounded-lg">
              <span className="text-2xl">🚛</span>
              <div>
                <p className="text-sm font-bold">Insured Shipping</p>
                <p className="text-xs opacity-70">Pan-India delivery</p>
              </div>
            </div>
          </div>

          {/* Made in India Badge */}
          <div className="flex justify-center mb-8">
            <div className="flex items-center gap-3 bg-white/10 px-6 py-3 rounded-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_1a0116e9-0e1c-4654-ab92-f289746b4b85/artifacts/k5jfyza7_ChatGPT%20Image%20Dec%2024%2C%202025%2C%2011_29_33%20AM.png"
                alt="Made in India"
                className="h-12 w-auto"
              />
              <div className="text-left">
                <p className="text-sm font-bold">Designed & Manufactured in India</p>
                <p className="text-xs opacity-70">Supporting Indian Manufacturing</p>
              </div>
            </div>
          </div>
          
          <div className="text-center">
            <p className="text-sm font-semibold">
              © 2025 Modular Furniture Store. All rights reserved.
            </p>
            <p className="text-xs mt-2 opacity-70">
              www.modularfurniturestore.com
            </p>
            <p className="text-xs mt-2 opacity-70">
              For queries: hello@modularfurniturestore.com | +91 95946 85818
            </p>
            
            {/* Policy Links */}
            <div className="mt-4 pt-4 border-t border-white/10">
              <div className="flex flex-wrap justify-center gap-3 text-xs opacity-60">
                <button onClick={() => setPolicyPopup(true)} className="hover:opacity-100 hover:underline transition-opacity">Shipping Policy</button>
                <span>|</span>
                <button onClick={() => setPolicyPopup(true)} className="hover:opacity-100 hover:underline transition-opacity">Privacy Policy</button>
                <span>|</span>
                <button onClick={() => setPolicyPopup(true)} className="hover:opacity-100 hover:underline transition-opacity">Refund Policy</button>
                <span>|</span>
                <button onClick={() => setPolicyPopup(true)} className="hover:opacity-100 hover:underline transition-opacity">Terms & Conditions</button>
                <span>|</span>
                <button onClick={switchToPremium} className="hover:opacity-100 hover:underline transition-opacity text-primary">Switch to Premium Theme →</button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms & Policies Popup */}
      <PolicyPopup open={policyPopup} onOpenChange={setPolicyPopup} />
    </>
  );
}

function PolicyPopup({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none max-w-2xl max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle className="text-2xl font-black uppercase">
            Terms & Policies
          </DialogTitle>
          <DialogDescription className="sr-only">
            Review our terms and policies
          </DialogDescription>
        </DialogHeader>
        
        <div className="overflow-y-auto flex-1 pr-2 -mr-2">
          {/* Quick Navigation */}
          <div className="flex flex-wrap gap-2 mb-6 pb-4 border-b border-border sticky top-0 bg-white">
            {['Shipping', 'Privacy', 'Cancellation & Refund', 'Terms & Conditions'].map((item, i) => (
              <button
                key={i}
                onClick={() => document.getElementById(`home-popup-${item.toLowerCase().replace(/ & /g, '-').replace(/ /g, '-')}`)?.scrollIntoView({ behavior: 'smooth' })}
                className="text-xs px-3 py-1 bg-secondary hover:bg-accent hover:text-accent-foreground transition-colors"
              >
                {item}
              </button>
            ))}
          </div>

          <div className="space-y-8 text-sm">
            {/* Shipping Policy */}
            <section id="home-popup-shipping" className="scroll-mt-16">
              <h3 className="text-lg font-black uppercase mb-2">Shipping & Delivery Policy</h3>
              <p className="text-xs text-muted-foreground mb-3">Last updated: Dec 25, 2025</p>
              <div className="text-muted-foreground space-y-2">
                <p>Orders are shipped within 0-7 days or as per the delivery date agreed at the time of order confirmation. For domestic buyers, orders are shipped through registered domestic courier companies and/or speed post only.</p>
                <p>MODULAR FURNITURE STORE is not liable for any delay in delivery by the courier company/postal authorities. Delivery of all orders will be to the address provided by the buyer.</p>
                <p>Contact: <strong>9820596811</strong> or <strong>hello@modularfurniturestore.com</strong></p>
              </div>
            </section>

            {/* Privacy Policy */}
            <section id="home-popup-privacy" className="scroll-mt-16">
              <h3 className="text-lg font-black uppercase mb-2">Privacy Policy</h3>
              <p className="text-xs text-muted-foreground mb-3">Last updated: Dec 25, 2025</p>
              <div className="text-muted-foreground space-y-2">
                <p>MODULAR FURNITURE STORE is committed to ensuring that your privacy is protected. We may collect: Name, Contact information, Email address, and other information relevant to customer surveys and offers.</p>
                <p>We use this information for internal record keeping, improving our products and services, and sending promotional emails about new products and special offers.</p>
                <p>We will not sell, distribute or lease your personal information to third parties unless required by law.</p>
              </div>
            </section>

            {/* Cancellation & Refund */}
            <section id="home-popup-cancellation-refund" className="scroll-mt-16">
              <h3 className="text-lg font-black uppercase mb-2">Cancellation & Refund Policy</h3>
              <p className="text-xs text-muted-foreground mb-3">Last updated: Dec 25, 2025</p>
              <div className="text-muted-foreground space-y-2">
                <p>We have implemented a "No Cancellation or Refund" policy once an order is placed.</p>
                <p><strong>Immediate Processing:</strong> Orders are automatically sent to production upon confirmation.</p>
                <p><strong>Inventory Commitment:</strong> Items are immediately reserved for you.</p>
                <p><strong>Resource Allocation:</strong> Labor and materials are committed upon finalization.</p>
                <p>Please double-check product specifications, shipping details, and compatibility before placing your order.</p>
              </div>
            </section>

            {/* Terms & Conditions */}
            <section id="home-popup-terms-conditions" className="scroll-mt-16">
              <h3 className="text-lg font-black uppercase mb-2">Terms & Conditions</h3>
              <p className="text-xs text-muted-foreground mb-3">Last updated: Dec 25, 2025</p>
              <div className="text-muted-foreground space-y-2">
                <p>MODULAR FURNITURE STORE is located in Mumbai City, Maharashtra, India.</p>
                <p>The content of this website is subject to change without notice. We do not provide any warranty or guarantee as to the accuracy of information on this website.</p>
                <p>Your use of any information or materials on our website is entirely at your own risk. Unauthorized use of information provided by us shall give rise to a claim for damages.</p>
                <p>Any dispute arising out of use of our website and/or purchase with us is subject to the laws of India.</p>
              </div>
            </section>

            {/* Contact */}
            <section className="bg-secondary p-4">
              <h3 className="text-sm font-bold uppercase mb-2">Contact Us</h3>
              <p className="text-muted-foreground text-xs">
                Merchant: MODULAR FURNITURE STORE | Tel: 9820596811 | Email: hello@modularfurniturestore.com
              </p>
            </section>
          </div>
        </div>

        <div className="flex-shrink-0 pt-4 border-t border-border mt-4">
          <Button 
            onClick={() => onOpenChange(false)} 
            className="w-full rounded-none uppercase tracking-wider font-bold"
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
